export const SUBMIT_ERROR_MESSAGE =
  "We weren't able to submit this form. Please refresh the page and try again.";
